export enum Direction {
  HOWDEN_TO_TELADOC = '>>',
  TELADOC_TO_HOWDEN = '<<'
}

export class DirectionValue {
  public static HOWDEN_TO_TELADOC = 'Howden  >  Teladoc';
  public static TELADOC_TO_HOWDEN = 'Teladoc >  Howden';
}